import React, { useEffect, useState } from "react";
import { loadMeta, isSampleNow } from "../../utils/stockApi.js";

export const Loading = () => <div className="co-loading">Loading…</div>;

export const ErrorBox = ({ error }) => (
  <div className="co-error">Could not load this data. {error && String(error.message || error)}</div>
);

export function SampleBanner() {
  const [sample, setSample] = useState(isSampleNow());
  useEffect(() => {
    let live = true;
    loadMeta().then((m) => live && setSample(!!m.sample));
    return () => { live = false; };
  }, []);
  if (!sample) return null;
  return null;
  //   (<div className="co-sample">
  //     <strong>Sample data.</strong> Prices, financials, estimates and ownership shown here are generated
  //     placeholders, not real market data.
  //   </div>
  // );
}

export function SubTabs({ items, value, onChange }) {
  return (
    <div className="co-subtabs" role="tablist">
      {items.map(([key, label]) => (
        <button
          key={key}
          role="tab"
          aria-selected={value === key}
          className={value === key ? "active" : ""}
          onClick={() => onChange(key)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export const Chips = ({ items, value, onChange }) => (
  <div className="co-chips">
    {items.map((c) => (
      <button key={c} className={value === c ? "active" : ""} onClick={() => onChange(c)}>
        {c}
      </button>
    ))}
  </div>
);
